import * as api from "../api/index";

export const ChannelService = {
  createChannel,
  updateChannel,
  getChannelList,
  getChannelDetailsById,
  getChannelListWithoutPagination,
  getRateCardChannelList
};

async function createChannel(formData) {
  try {
    const { data } = await api.createChannel(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateChannel(formData) {
  try {
    const { data } = await api.updateChannel(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getChannelList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getChannelList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getChannelListWithoutPagination() {
  try {
    const { data } = await api.getChannelListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getRateCardChannelList(values) {
  try {
    const { data } = await api.getRateCardChannelList(values);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getChannelDetailsById(values) {
  try {
    const { data } = await api.getChannelDetailsById(values);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}